import { StatisticsUserControls } from './components/statistics-user-controls.tsx'
import { StatisticsTable } from './components/statistics-table.tsx'
import { useRef } from 'react'
import { useTableHeight } from '../../common/hooks/use-table-height.ts'

export const Statistics = () => {
  const headerRef = useRef<HTMLDivElement>(null)
  const tableHeight = useTableHeight(headerRef)

  return (
    <>
      <div ref={headerRef}>
        <StatisticsUserControls />
      </div>
      <StatisticsTable height={tableHeight} />
    </>
  )
}
